module.exports = __webpack_public_path__ + "img/测训制证.11856eb6.png";